<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br />
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">From Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled" />
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate" />
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled" />
              <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate" />
            </div>
            <div class="p-field p-col-12 p-md-2 p-mt-5">
              <Button @click.prevent="searchItemMargin" class="p-button-raised" label="Search" icon="pi pi-search" />
            </div>
          </div>
        </form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <!-- <a href="#" class="p-field p-col-12 p-md-12" @click.prevent="exportCSV()"
              v-if="itemMarginData.length > 0">
              <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;" />
            </a> -->
            
            <DataTable :value="itemMarginData" :paginator="true" :rows="100" 
                       :filters="filters" :rowsPerPageOptions="[100, 500, 1000]" 
                       class="p-datatable-responsive p-datatable-gridlines" 
                       data-key="id">
              <Column header="S.N">
                <template #body="sl">
                  {{ sl.index + 1 }}
                </template>
              </Column>
              <Column header="Transaction Date" :sortable="true" field="transactionDate">
                <template #body="slotProps">
                    {{ formatDate(slotProps.data.transactionDate) }}
                </template>
                <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['transactionDate']" />
                </template>
                </Column>
                 <Column header="Transaction Date Nepali" :sortable="true" field="transactionDateNepali">
                <template #body="slotProps">
                    {{ formatDate(slotProps.data.transactionDateNepali) }}
                </template>
                <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['transactionDateNepali']" />
                </template>
                </Column>
              <Column header="Account Name" :sortable="true" field="accountName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['accountName']" />
                </template>
              </Column>
              <Column header="Narration" :sortable="true" field="narration" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['narration']" />
                </template>
              </Column>
              <Column header="Transaction Amount" :sortable="true" field="transactionAmount" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['transactionAmount']" />
                </template>
                <template #footer>
                  {{ totalExpensesAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Org Name" :sortable="true" field="orgName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['orgName']" />
                </template>
              </Column>
              <template #empty>No record found</template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import InputMask from 'primevue/inputmask'
import MultiSelect from 'primevue/multiselect'
import Dropdown from 'primevue/dropdown'
// import globalKey from '../../../store/globalKey'
// import axios from 'axios'
import $ from 'jquery'

export default {
  name: 'ExpensesReport',
  data() {
    return {
      fromDate: null,
      toDate: null,
      loading: false,
      filters: {},
      englishDateEnabled: true,
      itemMarginData: [],
      totalExpensesAmount: 0
    }
  },
  computed: {
  },
  async mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async searchItemMargin() {
      this.loading = true
      try {
        const payload = {
          fromDate: this.fromDate,
          toDate: this.toDate
        }
        const response = await this.$store.dispatch('loadExpensesReport', payload)
        this.itemMarginData = response.data.data
        this.totalExpensesAmount = this.itemMarginData.reduce((sum, item) => {
          return sum + (item.transactionAmount || 0)
        }, 0)
        if (this.itemMarginData.length === 0) {
          this.$toast.add({
            severity: 'info',
            summary: '',
            detail: 'No data found for the selected criteria',
            life: 3000
          })
        }
      } catch (error) {
        console.error('Error loading item margin report:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load item margin data',
          life: 3000
        })
      } finally {
        this.loading = false
      }
    },
    // exportCSV() {
    //   const data = {
    //     fromDate: this.fromDate,
    //     toDate: this.toDate,
    //     itemIds: this.selectedItems.length > 0
    //       ? this.selectedItems.map(item => item.id)
    //       : null
    //   }
    //   axios({
    //     url: globalKey + '/fileDownload/excelItemMarginReport/' +
    //          this.$store.getters.organisationId + '/' +
    //          this.$store.getters.userId + '/' +
    //          data.fromDate + '/' +
    //          data.toDate + '/' +
    //          (data.itemIds ? data.itemIds.join(',') : 'all'),
    //     method: 'get',
    //     headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
    //     responseType: 'blob'
    //   }).then((response) => {
    //     const url = window.URL.createObjectURL(new Blob([response.data]))
    //     const link = document.createElement('a')
    //     link.href = url
    //     link.setAttribute('download', 'item_margin_report.xlsx')
    //     document.body.appendChild(link)
    //     link.click()
    //     link.remove()
    //     window.URL.revokeObjectURL(url)
    //   })
    // },
    formatDate(val) {
      if (!val) return ''
      const m = String(val).match(/^\d{4}-\d{2}-\d{2}/)
      return m ? m[0] : ''
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false ||
          this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
      } else {
        this.englishDateEnabled = false
      }
    },
    reset() {
      if (!this.$store.getters.englishDate ||
          this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.setEnglishDate()
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    InputText,
    Button,
    InputMask,
    MultiSelect,
    Dropdown
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// expensesReport.vue?386c451e